import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/router/pages/HomePage.vue'
import SearchPage from '@/router/pages/SearchPage.vue'
import BrowsePage from '@/router/pages/BrowsePage.vue'
import DownloadPage from '@/router/pages/DownloadPage.vue'
import HelpPage from '@/router/pages/HelpPage.vue'
import TCRDetailPage from '@/router/pages/TCRDetailPage.vue'
import DiseaseDetailPage from '@/router/pages/DiseaseDetailPage.vue'

const router = createRouter({
  history: createWebHistory('/reactcr/'),
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/search',
      name: 'Search',
      component: SearchPage
    },
    {
      path: '/browse',
      name: 'Browse',
      component: BrowsePage
    },
    // {
    //   path: '/download',
    //   name: 'Download',
    //   component: DownloadPage
    // },
    {
      path: '/help',
      name: 'Help',
      component: HelpPage
    },
    {
      path: '/tcr/:id',
      name: 'TCRDetail',
      component: TCRDetailPage,
      props: true
    },
    {
      path: '/disease/:disease',
      name: 'DiseaseDetail',
      component: DiseaseDetailPage,
      props: true
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})

export default router 